import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import VueApexCharts from 'vue3-apexcharts'

import * as generalFunctions from './generalFunctions.js';

loadFonts()

const app = createApp(App);
app.provide('$generalFunctions', generalFunctions);
app.use(router)
app.use(vuetify)
app.use(VueApexCharts)  
app.mount('#app')